import React, { FunctionComponent, useContext } from 'react';
import reactStringReplace from 'react-string-replace';

import Product from 'models/Product';

import { formatHtml } from 'utils/string';

import LocaleContext from 'components/context/Locale';
import HtmlStyledContent from 'components/layout/HtmlStyledContent/component';
import OfferBoxProduct from 'components/modules/public/products/OfferBoxProduct';

import { DraftReplaceKeys, Props } from './index';
import StyledComponent from './styles';

const PublicBlogsArticleContent: FunctionComponent<Props> = ({ content, article }) => {
    const localeContext = useContext(LocaleContext);
    const translations = {
        ...localeContext?.translations?.blockSectionPackages,
    };

    const displayedProducts = [];
    const html = formatHtml(content);

    const replaceWithOfferBox = (products: Product[]) => {
        return (
            <div className='offer-boxes'>
                {products?.map((element) => (
                    <OfferBoxProduct
                        key={element.id}
                        product={element}
                        {...translations.copy}
                    />
                ))}
            </div>
        );
    };

    const arrayHtml = reactStringReplace(html, /<p>.*(RelatedProducts).*<\/p>/gm, (match) => {
        switch (match) {
            case DraftReplaceKeys.Products:
                if (!displayedProducts?.length) {
                    displayedProducts.push(article?.products);
                    return article?.products
                        ? replaceWithOfferBox(article?.products)
                        : null;
                } else {
                    return null;
                }
        }
    });


    return (
        <StyledComponent className="public-blogs-article-content">
            {arrayHtml?.map((element) => {
                switch (typeof element) {
                    case 'string':
                        return <HtmlStyledContent html={element} />;
                    default:
                        return element;
                }
            })}
        </StyledComponent>
    );
};

export default PublicBlogsArticleContent;
